import { ProfileCard } from './ProfileCard';
import ProfileEmptySection from './ProfileEmptySection';
import type { EmptyStateStyling } from './ProfileEmptySection';
import { ArrowUpRight } from 'lucide-react';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PortfolioAndProjectsEditModal } from '../Edit/PortfolioAndProjectsEditModal';
import { Modal } from '@sandtech-hub-monorepo/ui-kit';

interface EmptyStateContent {
  header: string;
  main: string;
  callToActionText: string;
  icon: JSX.Element;
}

interface Props {
  urls: string[];
  /** Card heading; defaults to central-hub's existing "Profile & Projects". */
  title?: string;
  /**
   * Renders a full empty state (Figma 10708-66006) when the list is empty.
   * Omitted by central-hub, which renders nothing for an empty list -
   * unchanged from before this prop.
   */
  emptyState?: EmptyStateContent;
  /** Empty-state visual overrides; omitted by central-hub. */
  emptyStateStyling?: EmptyStateStyling;
}

export const PortfolioAndProjectsSection = ({
  urls,
  title = 'Profile & Projects',
  emptyState,
  emptyStateStyling,
}: Props) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <ProfileCard
        title={title}
        action={() => setOpen(true)}
        editable
        className="flex-1"
      >
        {!urls.length && emptyState ? (
          <ProfileEmptySection
            header={emptyState.header}
            main={emptyState.main}
            callToActionText={emptyState.callToActionText}
            callToAction={() => setOpen(true)}
            icon={emptyState.icon}
            {...emptyStateStyling}
          />
        ) : (
          <div className="flex flex-col gap-2">
            {urls.map((url) => (
              <Link
                target="_blank"
                to={url}
                key={url}
                className="flex text-primary gap-1 hover:underline"
              >
                {url.replace('https://', '')}
                <ArrowUpRight />
              </Link>
            ))}
          </div>
        )}
      </ProfileCard>
      <Modal open={open} onOpenChange={setOpen}>
        <PortfolioAndProjectsEditModal
          close={() => setOpen(false)}
          defaultUrls={urls}
        />
      </Modal>
    </>
  );
};
